import React, { useContext, useEffect } from "react";
import { styled } from '@mui/material/styles';
import { Grid, Chip } from '@mui/material';
import { DataContext } from "../context/DataContext";
import { mainBlue, mainGray, highlightGray, hoverRed } from "../GlobalUtilities/Styles";
import { CountryDropDown, StateDropDown, CityDropDown, CategoryDropDown, DivisionDropDown, StatusDropDown } from "../GlobalUtilities/DataLists";

const Banner = styled('div')`
    margin:20px 0;
    color: ${mainGray};
`;

const FilterReset = styled('div')`
    text-align:left;
    margin-left:5px;
    margin-right: 5px;
`;

const FilterResetButton = styled('button')`
    background-color:${hoverRed};
    color:#fff;
    border:none;
    padding:5px 10px;
    border-radius:3px;
    font-size: 1.1em;
    :hover {
        color: ${mainBlue};
        background-color: ${highlightGray};
        cursor:pointer;
    }
`;

const FilterLabels = styled('div')`
    text-align:right;
    margin-right:5px;

    @media (max-width: 600px) { /* xs size (example threshold) */
    text-align: right;
  }
`;

const FilterContainer = styled('div')`
    display:flex;
    flex-wrap: wrap;
    gap:5px;
`;

const Highlight = styled('span')`
    color: ${mainBlue};
`;

const StyledChip = styled(Chip)`
    background-color: ${mainBlue};
    color: #fff;
    &:hover {
        background-color: ${mainBlue};
    }
    .MuiChip-deleteIcon {
        color: #fff;
        &:hover {
            color: ${hoverRed};
        }
    }
`;



const JobBanner = () => {

    const { originalJobData, jobData, locationFilter, setLocationFilter, setCountryList, setStateList, setCityList, setCategoryList, setDivisionList, setStatusList, setMapReset } = useContext(DataContext);

    const filterDelete = (value) => {
        setLocationFilter((prevFilters) => prevFilters.filter(item => item.value !== value));
    }

    const filterReset = () => {
        setLocationFilter([]);
        //Country
        setCountryList(CountryDropDown({ data: originalJobData }));
        //State
        setStateList(StateDropDown({ data: originalJobData }));
        //City
        setCityList(CityDropDown({ data: originalJobData }));
        //Category
        setCategoryList(CategoryDropDown({ data: originalJobData }));
        //Division
        setDivisionList(DivisionDropDown({ data: originalJobData }));
        //Status
        setStatusList(StatusDropDown({ data: originalJobData }));
    };

    useEffect(() => {
        if (locationFilter.length === 0) {
            // Toggle the mapReset to trigger a map reload
            setMapReset(prev => !prev); 
        }
    }, [locationFilter, setMapReset]);

    return (
        <Banner>
            <Grid container>
                <Grid item xs={4} md={2}>
                    <FilterReset>
                        <FilterResetButton onClick={filterReset}>Reset Filters</FilterResetButton>
                    </FilterReset>
                </Grid>
                <Grid item xs={2} md={1}>
                    <FilterLabels>Filters:</FilterLabels>
                </Grid>
                <Grid item xs={6} md={6}>
                    <FilterContainer>
                        {locationFilter.map((item) => (
                            <StyledChip
                                key={item.value}
                                size="small"
                                //If Filter is Status render Part Time or Full Time text, values are accutally true or false.
                                label={item.label === 'Status' && item.value === true ? 'Full Time' : item.label === 'Status' && item.value === false ? 'Part Time' : item.value}
                                onDelete={() => filterDelete(item.value)} />
                        ))}
                    </FilterContainer>

                </Grid>
                <Grid item xs={12} md={3}>
                    <FilterLabels>
                        <Highlight>{jobData.length} </Highlight>of <Highlight>{originalJobData.length}</Highlight> Jobs Displayed
                    </FilterLabels>
                </Grid>
            </Grid>
        </Banner>
    )
}

export default JobBanner;